import { PriceEntity } from '../../Entities/index.exports';
import { BasePriceFrontEndApiCalls } from '../index.exports';

//TODO: eliminar esta clase, no se usa
export class PriceApi extends BasePriceFrontEndApiCalls {
    protected static _Entity = PriceEntity;

    // #region api

    // #endregion api
}
